module.exports = __webpack_public_path__ + "media/public/img/musement-review-widget-01-cdcb82dea4530aa52f361e0f447f8f5f.svg";